import React, { Component } from "react";
import Chart from 'react-apexcharts';
import { initSeriesData, SERIES_NAME, setOptions, updateSeriesData } from "./model";
import { withTranslation } from "react-i18next";


class EnergyChart extends Component {
  constructor(props) {
    super(props);
    this.state = {
      graphData: initSeriesData(props.t),
      batteryChargeSeries: [],
      batteryDischargeSeries: [],
      demandSeries: [],
      solarPredictionSeries: [],
      solarSeries: [],
    } 
  }

  componentDidUpdate(prevProps) {
    const {
      solarSeries,
      demandSeries,
      batteryChargeSeries,
      batteryDischargeSeries,
      solarPredictionSeries,
      t
    } = this.props;
    // 언어 변경 감지 - graphData 전체를 다시 초기화
    if (prevProps.t !== t) {
      this.setState({
        graphData: initSeriesData(t)
      }, () => {
        // 초기화 후 현재 데이터로 다시 업데이트
        if (solarSeries) this.updateData(solarSeries, SERIES_NAME(t).solar);
        if (demandSeries) this.updateData(demandSeries, SERIES_NAME(t).demand);
        if (batteryChargeSeries) this.updateData(batteryChargeSeries, SERIES_NAME(t).batteryCharge);
        if (batteryDischargeSeries) this.updateData(batteryDischargeSeries, SERIES_NAME(t).batteryDischarge);
        if (solarPredictionSeries) this.updateData(solarPredictionSeries, SERIES_NAME(t).solarPrediction);
      });
      return; // 언어 변경 시 아래 로직 스킵
    }

    if (prevProps.solarSeries !== solarSeries) {
      this.updateData(solarSeries, SERIES_NAME(t).solar);
    }
    if (prevProps.demandSeries !== demandSeries) {
      this.updateData(demandSeries, SERIES_NAME(t).demand);
    }
    if (prevProps.batteryChargeSeries !== batteryChargeSeries) {
      this.updateData(batteryChargeSeries, SERIES_NAME(t).batteryCharge);
    }
    if (prevProps.batteryDischargeSeries !== batteryDischargeSeries) {
      this.updateData(batteryDischargeSeries, SERIES_NAME(t).batteryDischarge);
    }
    if (prevProps.solarPredictionSeries !== solarPredictionSeries) {
      this.updateData(solarPredictionSeries, SERIES_NAME(t).solarPrediction);
    }
  }

  updateData(data, name) {
    const { graphData } = this.state;
    const updatedData = updateSeriesData({
      seriesData: graphData,
      updateData: data,
      name,
    });
    this.setState({
      graphData: updatedData || graphData,
    });
  }
  render() {
    const { graphData } = this.state;
    const { t } = this.props;
    return (
      <Chart options={setOptions(graphData, t)} series={graphData || []} type="line" height={330} />
    )
  }
}

export default withTranslation()(EnergyChart);
